import React from "react";
import { Link } from "react-router-dom";

const Projects = () => {
  const allProjects = [
    {
      title: "Trankyl",
      description: "Écosystème complet de services à la demande, offrant une expérience fluide et intégrée pour les utilisateurs. Je pilote le développement technique de l'ensemble de la plateforme.",
      links: [
        { label: "Site Web", url: "https://trankyl.com/fr", icon: "fa-globe" },
        { label: "App Store (Client)", url: "https://apps.apple.com/fr/app/trankyl/id1547815509", icon: "fa-apple" },
        { label: "App Store (Prestataire)", url: "https://apps.apple.com/us/app/trankyl-heros/id1548459730", icon: "fa-apple" },
        { label: "Play Store (Client)", url: "https://play.google.com/store/apps/details?id=com.trankyl.client", icon: "fa-android" },
        { label: "Play Store (Prestataire)", url: "https://play.google.com/store/apps/details?id=com.trankyl.vhero&hl=en_IN&gl=US", icon: "fa-android" },
      ]
    },
    {
      title: "Safe SOS",
      description: "Solution de sécurité innovante permettant l'envoi d'alertes d'urgence instantanées et une gestion optimisée des secours.",
      links: [
        { label: "Site Web", url: "https://www.scinnovations.app/", icon: "fa-globe" },
        { label: "App Store", url: "https://apps.apple.com/ca/app/safe-sos/id6740741308", icon: "fa-apple" },
        { label: "Play Store", url: "https://play.google.com/store/apps/details?id=com.smartech.safe", icon: "fa-android" },
      ]
    },
    {
      title: "PHOENIX-UEMOA",
      description: "Plateforme de gestion et de suivi stratégique pour la région UEMOA, facilitant la collaboration institutionnelle et la centralisation des données régionales.",
      links: []
    },
    {
      title: "Pressy",
      description: "Fondateur & Développeur — Application innovante de pressing permettant aux utilisateurs de localiser facilement les prestataires à proximité. Les gérants de pressing peuvent y référencer leurs établissements et proposer leurs services directement via la plateforme.",
      links: [
        { label: "Play Store", url: "https://play.google.com/store/apps/details?id=com.smartech.pressy", icon: "fa-android" },
      ]
    },
    {
      title: "Cospend",
      description: "Fondateur & Développeur — Solution de gestion de dépenses partagées, permettant aux utilisateurs de suivre et de répartir leurs coûts de manière équitable, tout en offrant diverses fonctionnalités de suivi financier collaboratif.",
      links: [
        { label: "Play Store", url: "https://play.google.com/store/apps/details?id=com.smartech.cospend", icon: "fa-android" },
      ]
    },
    {
      title: "Voyage Simple",
      description: "Plateforme dédiée à la planification et à la réservation de voyages, simplifiant l'expérience utilisateur et l'organisation logistique pour les voyageurs.",
      links: []
    },
    {
      title: "Student@Stack",
      description: "Fondateur & Développeur — Espace numérique éducatif permettant aux étudiants de centraliser leurs outils académiques, cours et projets collaboratifs.",
      links: []
    },
    {
      title: "Krypton",
      description: "Plateforme spécialisée dans la production audiovisuelle, optimisant la gestion et la diffusion de contenus pour les professionnels du secteur créatif.",
      links: []
    },
    {
      title: "Mirrora",
      description: "Fondateur & Développeur — Solution technique performante de mise en miroir et de contrôle d'écran, offrant des fonctionnalités avancées similaires à Vysor pour une interaction fluide entre appareils.",
      links: []
    }
  ];

  return (
    <div className="projects-page" style={{ paddingTop: "120px", paddingBottom: "80px", background: "#f9f9f9" }}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="main-title text-center wow fadeIn">
              <h3>Profil & Réalisations</h3>
              <div className="underline1" style={{ backgroundColor: "#005C63" }}></div>
              <div className="underline2" style={{ backgroundColor: "#005C63" }}></div>
              <p style={{ maxWidth: "800px", margin: "20px auto" }}>
                Découvrez l'ensemble de mes réalisations techniques. Cette liste regroupe mes projets publics 
                et mes contributions majeures en tant qu'Ingénieur Logiciel.
              </p>
            </div>
          </div>
        </div>

        <div className="row" style={{ marginTop: "50px" }}>
          {allProjects.map((project, index) => (
            <div className="col-md-12" key={index} style={{ marginBottom: "40px" }}>
              <div className="project-list-item wow fadeIn" style={{ 
                background: "#fff", 
                padding: "30px", 
                borderRadius: "12px", 
                boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
                borderLeft: "5px solid #005C63"
              }}>
                <h4 style={{ 
                  fontFamily: "'Roboto Slab', serif", 
                  fontSize: "24px", 
                  fontWeight: "600", 
                  color: "#333",
                  marginBottom: "15px"
                }}>{project.title}</h4>
                <p className="text-justify" style={{ fontSize: "16px", color: "#666", lineHeight: "1.6" }}>
                  {project.description}
                </p>
                {project.links.length > 0 && (
                  <div className="project-links" style={{ marginTop: "20px", display: "flex", flexWrap: "wrap", gap: "15px" }}>
                    {project.links.map((link, lIndex) => (
                      <a 
                        key={lIndex} 
                        href={link.url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "8px",
                          padding: "8px 16px",
                          borderRadius: "20px",
                          background: "rgba(0, 92, 99, 0.1)",
                          color: "#005C63",
                          fontSize: "14px",
                          fontWeight: "500",
                          textDecoration: "none",
                          transition: "all 0.3s ease"
                        }}
                        onMouseOver={(e) => { e.currentTarget.style.background = "#005C63"; e.currentTarget.style.color = "#fff"; }}
                        onMouseOut={(e) => { e.currentTarget.style.background = "rgba(0, 92, 99, 0.1)"; e.currentTarget.style.color = "#005C63"; }}
                      >
                        <i className={`fa ${link.icon}`}></i> {link.label}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="row" style={{ marginTop: "40px" }}>
          <div className="col-md-12 text-center">
            <div className="confidential-note wow fadeIn" style={{
              padding: "20px",
              background: "rgba(0, 92, 99, 0.05)",
              borderRadius: "8px",
              display: "inline-block",
              border: "1px dashed #005C63"
            }}>
              <p style={{ margin: 0, fontStyle: "italic", color: "#666" }}>
                <i className="fa fa-lock" style={{ marginRight: "10px", color: "#005C63" }}></i>
                Note : Pour des raisons de confidentialité (NDA), certains projets stratégiques ne sont pas listés publiquement.
              </p>
            </div>
          </div>
        </div>

        <div className="row" style={{ marginTop: "60px" }}>
          <div className="col-md-12 text-center">
            <Link to="/" className="about-link-1" style={{ background: "#005C63", borderColor: "#005C63", color: "#fff" }}>
              Retour à l'accueil
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
